/*==============================================================================
TRESTLE
MANAGE MEMBERSHIP

File    : TRESTLE_Manage_Membership.js
Version : 1.0

Responsibilities
----------------
• Initialize Manage Membership
• Format membership expiry
==============================================================================*/

(() => {

"use strict";


const State = {
    initialized:false
};


const UI = {};


/*==============================================================================
INITIALIZE
==============================================================================*/

function initialize(){

    if(State.initialized){
        return;
    }


    UI.root =
        document.getElementById(
            "trManageMembership"
        );


    if(!UI.root){
        return;
    }


    State.initialized = true;


    UI.expiry =
        document.getElementById(
            "trMmExpiry"
        );


    formatExpiry();


    console.info(
        "TRESTLE Manage Membership Ready"
    );

}


/*==============================================================================
FORMAT EXPIRY
==============================================================================*/

function formatExpiry(){

    if(!UI.expiry){
        return;
    }


    const raw =
        String(
            UI.expiry.dataset.rawDate || ""
        ).trim();


    if(!raw){
        return;
    }


    const match =
        raw.match(
            /^(\d{4})-(\d{2})-(\d{2})/
        );


    if(!match){
        return;
    }


    const year =
        Number(match[1]);

    const month =
        Number(match[2]);

    const day =
        Number(match[3]);


    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];


    if(
        month < 1 ||
        month > 12 ||
        day < 1 ||
        day > 31
    ){
        return;
    }


    UI.expiry.textContent =
        day +
        " " +
        months[month - 1] +
        " " +
        year;

}


/*==============================================================================
PUBLIC API
==============================================================================*/

window.TrestleManageMembership = {

    initialize

};


/*==============================================================================
BOOT
==============================================================================*/

if(
    document.readyState === "loading"
){

    document.addEventListener(
        "DOMContentLoaded",
        initialize
    );

}

else{

    initialize();

}

})();